import React, {useState} from 'react';
import styles from './index.module.scss';
import CustomLink from "../../CustomLink";
import Dropdown from "./Dropdown";

import headerLogo from '../../../assets/icons/logo/white_logo.webp';
import burger from '../../../assets/icons/burger.svg';
import {ReactComponent as IconClose} from '../../../assets/icons/x_mark.svg';
import chat from '../../../assets/icons/chat.svg';
import car_crash from '../../../assets/icons/car_crash.svg';
import cx from "classnames";
import { createPortal } from "react-dom";
// import facebook from "../../../assets/icons/socials/facebook.svg";
// import linkedIn from "../../../assets/icons/socials/linkedIn.svg";
// import twitter from "../../../assets/icons/socials/twitter.svg";
// import youtube from "../../../assets/icons/socials/youtube.svg";
// import instagram from "../../../assets/icons/socials/instagram.svg";

const ELEMENTS = [
  {
    title: 'Car Reviews',
    link: '/cars'
  },
  {
    title: 'Sell Your Car',
    link: '/sell'
  },
  {
    title: 'Get Best Deals',
    link: '/check_availability'
  },
  {
    title: 'Products',
    items: [
      {
        title: 'AI Assistant',
        text: 'Our chatbot gets to know your preferences and tailors advice accordingly.',
        icon: chat,
        onClick: () => {
          // @ts-ignore
          window.Botsonic?.('open')
        }
      },
      {
        title: 'Car Insurance',
        text: 'Get the best rates by seeing multiple quotes at one time.',
        icon: car_crash,
        link: '/insurance'
      }
    ]
  }
]

const Header = () => {
  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  return createPortal((
    <nav className={styles.root}>
      <div className={styles.wrapper}>
        <CustomLink to='/'>
          <img src={headerLogo} alt="AutoEasy logo" className={styles.logo}/>
        </CustomLink>

        <div className={styles.list}>
          {ELEMENTS.map(({title, link, items}, i) => {
            return (
              <React.Fragment key={i}>
                {items ? (
                  <Dropdown items={items} title={title} />
                ) : (
                  <CustomLink to={link}>
                    <p className={styles.link}>{title}</p>
                  </CustomLink>
                )}
              </React.Fragment>
            )
          })}
        </div>

        <img className={styles.burger} src={burger} alt="menu"
             onClick={setOpenMobileMenu.bind(null, true)}/>

        <div className={cx(styles.menuWrapper, {[styles.active]: openMobileMenu})}>
          <div className={styles.darken} onClick={setOpenMobileMenu.bind(null, false)}/>
          <div className={styles.menu}>
            <div className={styles.header}>
              <CustomLink to='/'>
                <img src={headerLogo} alt="AutoEasy logo" className={styles.logo}/>
              </CustomLink>

              <IconClose className={styles.close} onClick={setOpenMobileMenu.bind(null, false)} />
            </div>
            <div className={styles.menuList}>
              {
                ELEMENTS.map(({title, link, items}, i) => {
                  return (
                    <React.Fragment key={i}>
                      <CustomLink to={link} >
                        <div className={styles.menuList__item}>
                          <p className={styles.menuList__text}>{title}</p>
                        </div>
                      </CustomLink>

                      {!!items && items.map(({title, text, link, icon, onClick}, i) => (
                        <CustomLink to={link} key={i}>
                          <div className={styles.subItem} onClick={onClick}>
                            <img src={icon} alt="Icon"/>
                            <div className={styles.flex}>
                              <p className={styles.subItem__title}>{title}</p>
                              <p className={styles.subItem__text}>{text}</p>
                            </div>
                          </div>
                        </CustomLink>
                      ))}

                      <div className={styles.divider}/>
                    </React.Fragment>
                  )
                })
              }

              {/*<div className={styles.socials}>*/}
              {/*  <p className={styles.socials__text}>Follow Us</p>*/}

              {/*  <div className={styles.flex}>*/}
              {/*    <img className={styles.socials__icon} src={facebook} alt="facebook"/>*/}
              {/*    <img className={styles.socials__icon} src={linkedIn} alt="linkedIn"/>*/}
              {/*    <img className={styles.socials__icon} src={twitter} alt="twitter"/>*/}
              {/*    <img className={styles.socials__icon} src={youtube} alt="youtube"/>*/}
              {/*    <img className={styles.socials__icon} src={instagram} alt="instagram"/>*/}
              {/*  </div>*/}
              {/*</div>*/}
            </div>
            <div className={styles.menuFooter}>
              <div className={styles.privacy}>
                <CustomLink to='/privacy_policy'>
                  <p className={styles.privacy__link}>Privacy</p>
                </CustomLink>
                <CustomLink to='/terms_of_service'>
                  <p className={styles.privacy__link}>Terms of Service</p>
                </CustomLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  ), document.getElementById("modal") as Element)
}

export default Header
